import React, { CSSProperties, PropsWithChildren } from "react";
import { extractIntercomArticleId } from "@shared/utils/misc";
import { useIntercom } from "react-use-intercom";
import Link from "common/Typography/Link";

interface IntercomLinkProps {
  articleId?: string;
  articleLink?: string;
  style?: CSSProperties;
  className?: string;
}

const IntercomLink = ({
  articleId: propsArticleId,
  articleLink,
  style,
  children,
  className,
}: PropsWithChildren<IntercomLinkProps>) => {
  const { showArticle } = useIntercom();
  const getArticleId = () => {
    if (propsArticleId) return propsArticleId;
    else if (articleLink) return extractIntercomArticleId(articleLink);
  };

  const articleId = getArticleId();
  const onPress = () => {
    if (articleId) {
      showArticle(parseInt(articleId));
    }
  };

  return (
    <Link onClick={onPress} style={style} className={className}>
      {children || "Learn More"}
    </Link>
  );
};

export default IntercomLink;
